import React, { useCallback, useContext, useEffect, useRef, useState, MouseEvent } from "react";
import { getTranslation } from "common";
import FlowentiLogo from "../../../image/Logo.svg"; //# use this cause is without background
import HelpIcon from '@mui/icons-material/Help';
import NotificationAddIcon from '@mui/icons-material/NotificationAdd';
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import {
  // Email as EmailIcon,
  // DataThresholding as DataThresholdingIcon,
  DashboardCustomize,
  QueryStats,
  Notifications as NotificationsIcon,
  KeyboardDoubleArrowRightRounded,
  KeyboardDoubleArrowLeftRounded,
  // KeyboardArrowDownRounded,
  PersonRounded,
  LockRounded,
  // SettingsRounded,
  // InfoRounded,
  LogoutRounded,
  MonitorRounded,
  ListAltRounded,
  GroupWorkRounded,
  PrecisionManufacturing,
  AutoStoriesOutlined,
  BrowseGalleryOutlined,
  Translate,
  HistoryOutlined,
  Cast,
  DarkMode,
  LightMode,
} from "@mui/icons-material";
import SearchBar from "../../../components/SearchBar";
import {
  Box,
  IconButton,
  List,
  Stack,
  Typography,
  Paper,
  Menu,
  MenuItem,
  Divider,
  Button,
  Tooltip,
  Popover,
  Badge,
  Dialog,
  Drawer,
} from "@mui/material";
import SideBarItem, {
  SideBarItemProps,
} from "./components/SideBarItem/SideBarItem";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Sidebar, SidebarHeader } from "./components/Sidebar";
import {
  useLLM,
  // useBreakpoint,
  useOrganizations,
  useSelectedOrganization,
  useSidebar,
  useSSE,
  useTranslations,
  useUser,
} from "hooks";
import {
  SelectedOrganization,
  PasswordDialog,
  RefreshApplication,
} from "components";
import { HEADER_HEIGHT } from "common/theme";
import { removeMessage } from "Redux/messageReducer";
import { AuthContext, ModalCoordinatorContext, NotificationContext, OrganizationsContext, ThemeModeContext, UtilityContext } from "contexts";
import AvatarRem from "components/AvatarRem";
import AiDrawer from "components/aiChat/AiDrawer";
import AiFab from "components/aiChat/AiFab";
import useKonamiCode from "hooks/useKonamiCode";
import CreditCardIcon from '@mui/icons-material/CreditCard';
import Billing from "components/dialogs/Billing";
import { set } from "lodash";
import NotificationsList from "components/NotificationsList";
import { Notification } from "model/notificationsModel";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import FlowentiButton from "components/flowenti-ui-kit/FlowentiButton";
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import TableChartIcon from '@mui/icons-material/TableChart';
import { resetProcessState } from "Redux/processReducer";

const SELECT_ORGANIZATIONS_ROUTES = [
  "process",
  "myactivities",
  "processes",
  "schedules",
  "statistics",
];
const DISABLE_GUIDE_ROUTES = ["process/edit", "robots", "process/insert"];
const GLOBAL_SEARCH_ROUTES = ["organizations"];
interface DashboardProps {
  getVersion: (id: number | null | undefined) => number;
  newestVersion: string;
}

const Dashboard: React.FC<DashboardProps> = ({ getVersion, newestVersion }) => {
  // const isMobile = useBreakpoint("down", "md");
  const [userMenu, setUserMenu] = useState<HTMLElement | null>(null);
  const user = useUser();
  const {
    actions: { logout },
  } = useContext(AuthContext);
  const {
    actions: { setModelChoice },
  } = useContext(UtilityContext);
  const {
    actions: { resetOrganizations },
  } = useContext(OrganizationsContext);
  const { mode, toggleThemeMode } = useContext(ThemeModeContext);
  const translations = useTranslations();
  const { pathname } = useLocation();
  const [openSecurityMenu, setopenSecurityMenu] = useState<boolean>(false);
  const routeName = pathname.split("dashboard/")[1].split("/")[0];
  const showSelectOrganizations: boolean =
    SELECT_ORGANIZATIONS_ROUTES.includes(routeName);
  const showGlobalSearch: boolean = GLOBAL_SEARCH_ROUTES.includes(routeName);
  const navigationSurfaceSx = {
    backgroundColor: (theme: any) =>
      theme.palette.mode === "dark"
        ? theme.palette.background.paper
        : theme.palette.grey[200],
  };
  const headerIconSx = {
    color: (theme: any) => theme.palette.text.secondary,
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: (theme: any) => theme.palette.action.hover,
      color: (theme: any) => theme.palette.primary.main,
    },
  };
  const dispatch = useDispatch();
  const [firstFilter, setFirstFilter] = useState<string>("");
  const [secondFilter, setSecondFilter] = useState<string>("");
  const [shouldShowSideBar, setShouldShowSideBar] = useSidebar();
  const organization = useSelectedOrganization()
  const organizationId = organization?.id

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  // Mobile side-drawer menu. The desktop permanent Sidebar is hidden
  // on mobile via display:none (see sx below) and replaced by this
  // hamburger-triggered Drawer so the screen real-estate stays free.
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { state: { notificationList } } = useContext(NotificationContext)
  const toReadNumberForOrg = notificationList?.filter(n => n.idorganization === organizationId && !n.readed).length

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  useOrganizations();

  const handleLogout = useCallback(() => {
    dispatch(removeMessage());
    dispatch(resetProcessState());
    resetOrganizations();
    logout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    window.addEventListener("logout", handleLogout);
    return () => window.removeEventListener("logout", handleLogout);
  }, [handleLogout]);

  const sideBarItems: SideBarItemProps[] = [
    {
      logoSrc: <GroupWorkRounded />,
      label: getTranslation(translations, "menu.left.organizations"),
      path: "organizations",
    },
    {
      logoSrc: <ListAltRounded />,
      label: getTranslation(translations, "menu.left.myactivities"),
      path: "myactivities",
    },
    {
      logoSrc: <AutoStoriesOutlined />,
      label: getTranslation(translations, "menu.left.operations"),
      path: "processes",
      children: [
        {
          logoSrc: <Cast />,
          // logoSrc: <PlayCircleOutline />,
          label: getTranslation(translations, "menu.left.live"),
          path: "processes",
        },
        {
          logoSrc: <HistoryOutlined />,
          label: getTranslation(translations, "menu.left.history"),
          path: "process-history",
        },
        {
          logoSrc: <ScheduleSendIcon />,
          label: getTranslation(translations, "menu.left.timer"),
          path: "schedules",
        },
      ],
    },
    {
      logoSrc: <DashboardCustomize />,
      label: getTranslation(translations, "menu.left.process"),
      path: "process",
    },
    {
      logoSrc: <QueryStats />,
      label: getTranslation(translations, "menu.left.statistics"),
      path: "statistics",
      // disabled: true,
    },
    {
      logoSrc: <PrecisionManufacturing />,
      label: getTranslation(translations, "my.robots.name"),
      // getTranslation(translations, "menu.left.notifications"),
      path: "robots",
      // disabled: true,
    },
    // {
    //   logoSrc: <NotificationsIcon />,
    //   label: getTranslation(translations, "menu.left.notifications"),
    //   path: "notifications",
    //   //disabled: true,
    // },
  ];

  // const icons = [NotificationsIcon, EmailIcon, DataThresholdingIcon];
  const menuItemsUser = [
    {
      name: getTranslation(translations, "account.profile.name"),
      action: () => {
        setUserMenu(null);
      },
      link: "/dashboard/profile",
      icon: <PersonRounded />,
      path: "profile",
    },
    {
      name: getTranslation(translations, "account.security.name"),
      action: () => {
        setopenSecurityMenu((_) => !_);
        setUserMenu(null);
      },
      icon: <LockRounded />,
      path: "security",
    },
    {
      name: getTranslation(translations, "billing"),
      action: () => {
        setUserMenu(null);
        // setBillingDialogOpen(true); 
      },
      icon: <CreditCardIcon />,
      path: "billing",
      link: `/dashboard/organizations/${organizationId}/billing`,
    },
    {
      name: getTranslation(translations, "generic.notifications_settings"),
      action: () => {
        setUserMenu(null);
        // setBillingDialogOpen(true); 
      },
      icon: <NotificationAddIcon />,
      path: "notifications/settings",
      link: "/dashboard/notifications/settings",
    },
    {
      name: getTranslation(translations, "account.support.name"),
      action: () => {
        setUserMenu(null);
      },
      icon: <HelpIcon />,
      path: "support",
      link: `profile/support`,
    },
    //hidden until they actually do something
    // {
    //   name: getTranslation(translations, "account.settings.name"),
    //   action: () => {},
    //   icon: <SettingsRounded />,
    //   path: "settings",
    // },
    // {
    //   name: getTranslation(translations, "account.help.name"),
    //   action: () => {},
    //   icon: <InfoRounded />,
    //   path: "help",
    // },
    {
      name: getTranslation(translations, "account.logout.name"),
      action: handleLogout,
      icon: <LogoutRounded />,
      path: "logout",
    },
  ];

  const {
    aiAnswers,
    handleSubmit,
    loading,
    llmInputRef,
    modelInputRef,
    openAI,
    setOpenAI,
    stopLLM,
    sessions,
    currentSessionId,
    startNewSession,
    loadSession,
    deleteSession,
    renameSession,
    handleRetry,
    searchSessions,
    searching,
    refreshSessions,
    modelProvider,
    setModelProvider,
    modelName,
    setModelName,
  } = useLLM("guide", true, true);

  const handleSubmitLLM = async () => {
    await handleSubmit({});
  };

  // ModalCoordinator: dismiss every other registered modal (e.g.
  // TaskDetailDialog, StartProcess, SequenceFlowsDialog) before opening
  // the AI drawer. Without this, the AI fab (z-index 9999999999999)
  // stays tappable on top of any backdrop, so the user could open the
  // AI while another dialog was visible — the AI would then render
  // behind the dialog and be invisible. Calling closeAll() up-front
  // ensures the AI is the only thing on screen.
  const { actions: modalActions } = useContext(ModalCoordinatorContext);
  const openAIExclusive = useCallback(
    (next: React.SetStateAction<boolean>) => {
      // Resolve the updater to a concrete boolean: if `next` is a
      // function, call it with the current state; otherwise take it
      // verbatim. We only run closeAllModals() when the resulting
      // value would actually open the AI (i.e. it transitions to true
      // or stays true across a function-updater that returns true).
      const resolved =
        typeof next === "function"
          ? (next as (prev: boolean) => boolean)(openAI)
          : next;
      if (resolved) {
        modalActions.closeAllModals(undefined);
      }
      setOpenAI(next);
    },
    [modalActions, openAI, setOpenAI]
  );

  useKonamiCode(
    ["f", "l", "o", "w", "e", "n", "t", "i", "2"],
    () => {
      setModelChoice(true);
    },
    { caseInsensitive: true, matchMode: "key" }
  );

  useEffect(() => {
    if (DISABLE_GUIDE_ROUTES.some((a) => pathname.includes(a))) {
      setOpenAI(false);
    }
  }, [pathname, setOpenAI]);
  if (pathname.includes("billing")) {
    return <Outlet
      context={{
        firstFilter,
        setFirstFilter,
        secondFilter,
        setSecondFilter,
      }}
    />
  }

  // Routes listed in DISABLE_GUIDE_ROUTES render their own <AiDrawer>
  // and <AiFab> (the child page owns the AI session there). Mounting
  // ours on top would create two independent AI states and a stacked
  // FAB / drawer, so we skip mounting anything AI-related on those
  // routes. See: process/insert, process/edit/:id, robots,
  // robots/:id/form-builder.
  const disableGuideHere = DISABLE_GUIDE_ROUTES.some((a) =>
    pathname.includes(a)
  );

  return (
    <React.Fragment>
      {!disableGuideHere && (
        <AiDrawer
          variant="persistent"
          modelInputRef={modelInputRef}
          llmInputRef={llmInputRef}
          LLMLoading={loading}
          aiAnswers={aiAnswers}
          handleSubmitLLM={handleSubmitLLM}
          openAI={openAI}
          setOpenAI={openAIExclusive}
          isDashboard={true}
          stopLLM={stopLLM}
          sessions={sessions}
          currentSessionId={currentSessionId}
          startNewSession={startNewSession}
          loadSession={loadSession}
          deleteSession={deleteSession}
          renameSession={renameSession}
          handleRetry={handleRetry}
          searchSessions={searchSessions}
          searching={searching}
          refreshSessions={refreshSessions}
          modelProvider={modelProvider}
          setModelProvider={setModelProvider}
          modelName={modelName}
          setModelName={setModelName}
        />
      )}
      {!disableGuideHere && <AiFab openAI={openAI} setOpenAI={openAIExclusive} />}
      <Stack direction="row">
        <Sidebar
          variant="permanent"
          open={shouldShowSideBar}
          sx={{
            // Hide the permanent sidebar on mobile — a hamburger in the
            // top header opens a temporary Drawer with the same items
            // (see the Drawer rendered further down this file).
            display: { xs: "none", md: "block" },
          }}
        >
          <SidebarHeader
            sx={{
              ...navigationSurfaceSx,
              boxShadow: "none",
              borderRight: (theme) => `1px solid ${theme.palette.divider}`,
              p: 0,
              pr: 3,
            }}
          >
            <>
              <Box
                component="img"
                alt="..."
                style={{
                  width: "48px",
                  height: "48px",
                  marginLeft: "4px",
                }}
                src={FlowentiLogo}
              />
              {shouldShowSideBar && (
                <Typography variant="h6">Flowenti</Typography>
              )}
            </>
          </SidebarHeader>
          <Stack
            sx={{
              flex: 1,
              ...navigationSurfaceSx,
              borderRight: (theme) => `1px solid ${theme.palette.divider}`,
            }}
            spacing={2}
          >
            <List
              id="menu-list"
              sx={{
                pt: "20px",
                boxShadow: "none",
                flex: 1,
              }}
            >
              <Box>
                <Tooltip
                  placement="right"
                  title={
                    shouldShowSideBar
                      ? getTranslation(
                        translations,
                        "generic.menu_reduce.caption"
                      )
                      : getTranslation(
                        translations,
                        "generic.open_menu.caption"
                      )
                  }
                >
                  <IconButton
                    sx={{
                      transition: "margin 0.3s",
                      ml: shouldShowSideBar ? "19px" : "9px",
                      mb: 3,
                      ...headerIconSx,
                    }}
                    id="organization-icon"
                    onClick={() => setShouldShowSideBar(!shouldShowSideBar)}
                  >
                    <MenuIcon />
                  </IconButton>
                </Tooltip>
                {sideBarItems.map((sideBarItem, index) => (
                  <SideBarItem
                    key={sideBarItem.label}
                    logoSrc={sideBarItem.logoSrc}
                    label={sideBarItem.label}
                    children={sideBarItem.children}
                    path={sideBarItem.path}
                    shouldShowLabel={shouldShowSideBar}
                    disabled={sideBarItem.disabled}
                  />
                ))}
              </Box>
            </List>
            <Box
              mt={35}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-end",
                py: 2,
                flex: 1,
              }}
            >
              <Divider sx={{ mb: 2, width: "78%" }} />
              {shouldShowSideBar ? (
                <FlowentiButton
                  variant="outlined"
                  startIcon={<LogoutRounded />}
                  onClick={handleLogout}
                >
                  {getTranslation(translations, "account.logout.name")}
                </FlowentiButton>
              ) : (
                <IconButton
                  sx={{
                    ...headerIconSx,
                    // backgroundColor: "rgba(84, 189, 193, 0.3)",
                    // "&:hover": {
                    //   backgroundColor: "rgba(84, 189, 193, 0.4)",
                    // },
                  }}
                  onClick={handleLogout}
                >
                  <LogoutRounded />
                </IconButton>
              )}
            </Box>
          </Stack>
        </Sidebar>
        <Stack flex={1}>
          <Stack
            component={Paper}
            direction="row"
            justifyContent={{ xs: "center", lg: "space-between" }}
            sx={{
              ...navigationSurfaceSx,
              boxShadow: "none",
              borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
              px: (_) => _.spacing(2),
              borderRadius: 0,
              height: HEADER_HEIGHT,
              // The navbar must not overflow horizontally on narrow
              // phones. minWidth: 0 lets the flex children shrink
              // past their intrinsic min-content width; overflow
              // hidden is a safety net so any rogue child that
              // doesn't shrink gets clipped instead of triggering a
              // horizontal scrollbar on the page.
              minWidth: 0,
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                minWidth: 0,
                flex: "1 1 auto",
                gap: 0.5,
                overflow: "hidden",
                "& > *": { flexShrink: 1, minWidth: 0 },
              }}
            >
              {/* Mobile hamburger: opens the side-drawer menu on mobile. */}
              <Tooltip
                title={getTranslation(translations, "generic.open_menu.caption") || "Menu"}
                placement="bottom"
              >
                <IconButton
                  id="mobile-hamburger-menu-btn"
                  onClick={() => setMobileMenuOpen(true)}
                  sx={{
                    ...headerIconSx,
                    display: { xs: "inline-flex", md: "none" },
                    mr: 1,
                    flexShrink: 0,
                  }}
                  aria-label="open menu"
                >
                  <MenuIcon />
                </IconButton>
              </Tooltip>
              {/* {showGlobalSearch && (
                <Box sx={{ display: "flex", flexGrow: 0 }}>
                  <SearchBar
                    id="search-bar-dash"
                    placeholder={getTranslation(
                      translations,
                      "pm.organizationchart.ricerca.placeholder"
                    )}
                    setFilter={(text: string) => {
                      setFirstFilter(text);
                      setSecondFilter(text);
                    }}
                  />
                </Box>
              )} */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  // minWidth: 0 is the critical fix here: without it
                  // this flex child has min-width: auto (= the
                  // intrinsic min-content of the buttons + selector)
                  // and forces the navbar wider than the viewport on
                  // iPhone-sized screens.
                  minWidth: 0,
                  flex: "1 1 0",
                  gap: 0.5,
                }}
              >
                <Box sx={{ flexShrink: 0, display: "flex" }}>
                  <RefreshApplication newestVersion={newestVersion} />
                </Box>
                {showSelectOrganizations && (
                  <Box
                    sx={{
                      // The organization selector is the only flex
                      // child of this group that can shrink. We cap
                      // its max width per breakpoint and let it
                      // absorb any leftover horizontal space.
                      ml: { xs: 0.5, sm: 1 },
                      flex: "1 1 0",
                      minWidth: 0,
                      maxWidth: { xs: 140, sm: 220 },
                    }}
                  >
                    <SelectedOrganization />
                  </Box>
                )}
                <Tooltip title={mode === "dark" ? "Light mode" : "Dark mode"}>
                  <IconButton sx={{ ...headerIconSx, flexShrink: 0 }} onClick={toggleThemeMode} id="dashboard-theme-toggle-btn">
                    {mode === "dark" ? <LightMode /> : <DarkMode />}
                  </IconButton>
                </Tooltip>
                <IconButton sx={{ ...headerIconSx, flexShrink: 0 }} onClick={handleClick} id="dashboard-notif-btn" disabled={pathname.includes('/notifications/list')}>
                  <Badge badgeContent={toReadNumberForOrg} color="error">
                    <NotificationsActiveIcon />
                  </Badge>
                </IconButton>
                <Popover
                  open={Boolean(anchorEl)}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  //anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                  //transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                  PaperProps={{
                    sx: {
                      width: 300,
                      overflow: "hidden",
                      marginTop: 8,
                      border: (theme) =>
                        theme.palette.mode === "dark"
                          ? "1px solid rgba(255, 255, 255, 0.24)"
                          : "none",
                    },
                  }}
                >
                  <NotificationsList compact onClose={handleClose} />
                </Popover>
              </Box>
            </Box>
            <Stack
              justifyContent="flex-end"
              direction="row"
              spacing={2}
              alignItems="center"
              sx={{ flexShrink: 0 }}
            >
              {/* The AI assistant is now opened from the floating action
                  button in the bottom-right corner (see <AiFab />). */}
              {/* <Stack
                sx={{ display: { lg: "flex" } }}
                direction="row"
                spacing={2}
                alignItems="center"
              > */}
              {/*
                    {icons.map((Icon, index) => (
                <IconButton
                  key={index}
                  sx={{
                    borderRadius: "6px",
                    backgroundColor: "rgba(84, 189, 193, 0.3)",
                    "&:hover": {
                      backgroundColor: "rgba(84, 189, 193, 0.4)",
                    },
                  }}
                >
                    <Icon sx={{ color: "rgba(84, 189, 193, 1)" }} />
                </IconButton>
              ))}
                     */}
              {/* </Stack> */}
              <IconButton
                id="profile-menu"
                key={getVersion(1)}
                sx={{ alignSelf: "flex-end", ...headerIconSx, flexShrink: 0 }}
                onClick={({ currentTarget }) => setUserMenu(currentTarget)}
              >
                {/* <Stack direction="row" alignItems="center" spacing={1}> */}
                <AvatarRem icon={user?.picture || ""}>
                  {user?.firstname[0]}
                  {user?.lastname[0]}
                </AvatarRem>
                {/* <KeyboardArrowDownRounded
                  sx={{
                    transform: userMenu ? "rotate(180deg)" : "rotate(0deg)",
                  }}
                /> */}
                {/* </Stack> */}
              </IconButton>
              <Menu
                disableScrollLock
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                onClose={() => setUserMenu(null)}
                MenuListProps={{
                  sx: { pt: 0 },
                }}
                open={Boolean(userMenu)}
                anchorEl={userMenu}
              >
                <MenuItem
                  sx={{
                    backgroundColor: (_) =>
                      _.palette.mode === "dark"
                        ? "rgba(255,255,255,0.16)"
                        : "rgba(0,0,0,0.16)",
                    fontWeight: "bold",
                    pointerEvents: "none",
                  }}
                >
                  {getTranslation(translations, "account.name")}
                </MenuItem>
                <Divider sx={{ mt: "0!important" }} />
                <MenuItem onClick={() => { }} disableRipple>
                  <Stack spacing={1} direction="row" alignItems="center">
                    <AvatarRem icon={user?.picture || ""}>
                      {user?.firstname[0]}
                      {user?.lastname[0]}
                    </AvatarRem>
                    <Stack spacing={1}>
                      <span style={{ fontWeight: "bold" }}>
                        {user?.firstname} {user?.lastname}
                      </span>
                      <span>{user?.email}</span>
                    </Stack>
                  </Stack>
                </MenuItem>
                <Divider sx={{ width: "87%", mx: "auto" }} />
                {menuItemsUser
                  .filter(
                    (item) =>
                      !(
                        item.path === "security" &&
                        user?.authenticationtype !== 0
                      )
                  )
                  .map((item, index) => (
                    <Link
                      key={item.name}
                      style={{ color: "inherit", textDecoration: "none" }}
                      to={item.link ? item.link : "#"}
                    >
                      <MenuItem id={`${item.path}-menu`} onClick={item.action}>
                        <Box
                          sx={{
                            color: "rgba(84, 189, 193, 1)",
                            borderRadius: "6px",
                            marginRight: "8px",
                            //   backgroundColor: "rgba(84, 189, 193, 0.3)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "4px",
                            // "&:hover": {
                            //   backgroundColor: "rgba(84, 189, 193, 0.4)",
                            // },
                          }}
                        >
                          {item.icon}
                        </Box>
                        {item.name}
                      </MenuItem>
                    </Link>
                    // <React.Fragment key={index}>
                    //   {index === menuItemsUser.length - 2 && (
                    //     <Divider sx={{ width: "70%", mx: "auto", mt: 5, mb: 2 }} />
                    //   )}
                    // </React.Fragment>
                  ))}
              </Menu>
            </Stack>
          </Stack>
          <PasswordDialog
            open={openSecurityMenu}
            setOpen={setopenSecurityMenu}
            onClose={() => setopenSecurityMenu(false)}
            uID={user?.userId}
          />
          <Box
            sx={{
              overflowX: "hidden",
              display: "flex",
              flexDirection: "column",
              // On mobile the permanent Sidebar is hidden and replaced by
              // the hamburger-triggered Drawer, so the main content can
              // take the full viewport width. On desktop we still subtract
              // the sidebar's width (open or closed) to leave room for it.
              maxWidth: { xs: "100vw", md: `calc(100vw - ${shouldShowSideBar ? 198 : 64}px)` },
              width: "100%",
              height: "calc(100vh - 61px)",
              minHeight: "calc(100vh - 61px)",
              maxHeight: "calc(100vh - 61px)",
              // marginLeft: 3,
              px: 2,
              pt: 2,
            }}
          >
            {/* <Typography
            flexShrink={0}
            sx={{
              mt: ".5em",
              mb: "0.4em",
              display: { xs: "none", md: "flex" },
            }}
            variant={isMobile ? "h6" : "h5"}
          >
            {getTranslation(translations, `menu.left.${routeName}`)}
          </Typography> */}

            <Outlet
              context={{
                firstFilter,
                setFirstFilter,
                secondFilter,
                setSecondFilter,
              }}
            />
          </Box>
        </Stack>
      </Stack>
      {/* <Dialog
        open={billingDialogOpen}
        onClose={() => setBillingDialogOpen(false)}
        scroll="paper"
        PaperProps={{
          sx: {
            width: '95vw',
            maxWidth: '95vw',
            borderRadius: 2,
            overflowX: 'hidden',
            overflowY: "auto",
            maxHeight: '100vh'
          },
        }}
      > */}
      {/* <Billing /> */}
      {/* </Dialog> */}

      {/* Mobile side-drawer menu. Anchored to the left, it hosts
          the same navigation items + logout button that the
          permanent Sidebar shows on desktop. Controlled by the
          hamburger button in the top header. */}
      <Drawer
        id="mobile-side-drawer"
        anchor="left"
        open={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
        ModalProps={{ keepMounted: true }}
        PaperProps={{
          sx: {
            width: "80vw",
            maxWidth: 320,
            ...navigationSurfaceSx,
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        {/* Header with logo + Flowenti label + close button */}
        <SidebarHeader
          sx={{
            ...navigationSurfaceSx,
            boxShadow: "none",
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
            p: 0,
            pr: 1,
            minHeight: `${HEADER_HEIGHT} !important`,
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            sx={{ flex: 1, minWidth: 0, pl: 1 }}
          >
            <Box
              component="img"
              alt="Flowenti"
              style={{ width: "36px", height: "36px" }}
              src={FlowentiLogo}
            />
            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
              Flowenti
            </Typography>
          </Stack>
          <IconButton
            id="mobile-side-drawer-close"
            onClick={() => setMobileMenuOpen(false)}
            aria-label="close menu"
            sx={{ ...headerIconSx }}
          >
            <CloseIcon />
          </IconButton>
        </SidebarHeader>

        {/* Navigation items — same list as the desktop sidebar */}
        <List
          sx={{
            flex: 1,
            overflowY: "auto",
            py: 1,
            "&::-webkit-scrollbar": { display: "none" },
            scrollbarWidth: "none",
          }}
        >
          {sideBarItems.map((sideBarItem) => (
            <Box key={sideBarItem.label}>
              <SideBarItem
                logoSrc={sideBarItem.logoSrc}
                label={sideBarItem.label}
                children={sideBarItem.children}
                path={sideBarItem.path}
                shouldShowLabel
                disabled={sideBarItem.disabled}
                onNavigate={() => setMobileMenuOpen(false)}
              />
            </Box>
          ))}
        </List>

        {/* Footer with logout + theme toggle */}
        <Stack
          sx={{
            borderTop: (theme) => `1px solid ${theme.palette.divider}`,
            p: 1.5,
            ...navigationSurfaceSx,
          }}
          spacing={1}
        >
          <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
            <Tooltip title={mode === "dark" ? "Light mode" : "Dark mode"}>
              <IconButton
                onClick={toggleThemeMode}
                sx={{ ...headerIconSx }}
                aria-label="toggle theme"
              >
                {mode === "dark" ? <LightMode /> : <DarkMode />}
              </IconButton>
            </Tooltip>
            <FlowentiButton
              variant="outlined"
              size="small"
              startIcon={<LogoutRounded />}
              onClick={() => {
                setMobileMenuOpen(false);
                handleLogout();
              }}
              sx={{ flex: 1 }}
            >
              {getTranslation(translations, "account.logout.name")}
            </FlowentiButton>
          </Stack>
        </Stack>
      </Drawer>
    </React.Fragment>
  );
};

export default Dashboard;
